const state = {
  apps: [],
  power3ParameterManagerApp: {
    parameters: {}
  },
  powerInvertWriteApp: {
    parameters: {}
  }
};

const mutations = {
  SET_PARAM_MANAGER_APP: (state, paramObj) => {
    state.power3ParameterManagerApp.parameters[paramObj.parameter] = paramObj.value;
  },
  SET_POWER_INVERTER_WRITE_APP: (state, paramObj) => {
    state.powerInvertWriteApp.parameters[paramObj.parameter] = paramObj.value;
  }
};

const actions = {
  setExpertViewParams(context, paramObj) {
    switch (paramObj.app) {
      case 'POWER3_PARAMETER_MANAGER_APP':
        context.commit('SET_PARAM_MANAGER_APP', paramObj);
        break;
      case 'POWER_INVERTER_WRITE_APP':
        context.commit('SET_POWER_INVERTER_WRITE_APP', paramObj);
        break;
      default:
        break;
    }
  }
};

const getters = {
  getExpertviewParams: state => [state.power3ParameterManagerApp, state.powerInvertWriteApp]
};

export default {
  state,
  mutations,
  actions,
  getters
};
